((ProductPersonalize, $) => {
  'use strict';

  // Default text color for ingot text and hr
  let generalIngotTextColor = '#5b5b5b';
  let currentIngotLookupSKU = null;

  const $dom = {};

  const cacheDom = () => {
    $dom.personalize = $('[data-personalize]')
    $dom.personalizeTriggerWrapper = $('[data-personalize-trigger-wrapper]')
    $dom.personalizeTrigger = $('[data-personalize-trigger]')
    $dom.personalizeDrawer = $('[data-personalize-drawer]')
    $dom.personalizeArrow = $('[data-personalize-arrow]')
    $dom.closeDrawer = $('.js-drawer-ingot-close')
    $dom.personalizeInput = $('[data-personalize-input]')
    $dom.personalizeError = $('[data-personalize-error]')
    $dom.personalizeTextColorSection = $(`[data-personalize-text-color-section]`)
    $dom.personalizeTextColorList = $(`[data-personalize-text-color-swatch-list]`)
    $dom.personalizeTextColorSelect = $(`[data-personalize-text-color-select]`)
    $dom.personalizeTextColorInput = $(`[data-personalization-text-color-input]`)
    $dom.personalizeTextColorReadableInput = $(`[data-personalization-text-color-readable-input]`)
    $dom.personalizeOrientation = $('[data-personalization-orientation]')
    $dom.personalizeOrientationText = $('[data-personalization-orientation-text]')
    $dom.personalizeOrientationInput = $('[data-personalization-orientation-input]')
    $dom.personalizeOrientationSelect = $('[data-personalize-orientation-select]')
    $dom.personalizeInitalsInput = $('[data-personalization-initials-input]')
    $dom.personalizeCollegeInput = $('[data-personalization-college-input]')
    $dom.personalizeOrientationVertical = $('[data-personalization-orientation="Vertical"]').first()
    $dom.ingotText = $('[data-ingot-text]')
    $dom.ingotDrawer = $('[data-ingot-drawer]')
  };

  /**
   * Checks if personalization is active on the current product.
   *
   * @return {boolean}: whether personalization is active
   */
  const canDisableATC = () => {
    const canDisable = $(".product--atc-button").attr('data-personalized-atc');
    return canDisable && canDisable === 'true';
  };

  const bindActions = () => {
    $(document).on(`initialSwatchSet`, () => {
      runProductPersonalize();
    });

    $dom.personalizeTrigger.on('click', (e) => {
      openPersonalization(e.target.closest('.product-personalize-wrapper'));
    });

    $dom.closeDrawer.on('click', (e) => {
      closePersonalization(e.target.closest('.product-personalize-wrapper'));
    });

    $dom.personalizeOrientation.on('click', (event) => {
      changePersonalizeOrientation(event.currentTarget)
    });

    $dom.personalizeInput.on("keydown", (event) => {
      if (/[^a-z0-9]/gi.test(event.key)) {
        event.preventDefault();
      }
    });

    $dom.personalizeInput.on("keyup", (event) => {
      changeInitals(event);
    });

    $dom.personalizeTextColorSelect.on(`change`, (e) => {
      const colorSelect = e.currentTarget;
      updateIngotTextColor(colorSelect.value, e.currentTarget.querySelector(`option[value="${colorSelect.value}"]`).textContent);
    });

    $(`body`).on(`click`, `[data-personalize-text-color-swatch]`, (e) => {
      setActiveTextColorSwatch(e.currentTarget);
    });

    $(document).ready(function () {
      initDrawer();
      initPersonalize();
      initIngotPersonalization();
    });
  };

  /**
   * openPersonalization - this function is poorly named, it actually toggles the personalization drawer.
   * @param {Element} parent
   */
  const openPersonalization = (parent) => {
    const drawer = parent.querySelector('[data-personalize-drawer]');
    const miyStep = parent.closest('.miy-step--personalized');
    $(drawer).slideToggle('slow');
    if (!miyStep) {
      $dom.personalizeTriggerWrapper.slideToggle('slow');

      $(".product--atc-button").attr("disabled", true);
      $(".product--atc-button").addClass(`disabled`);
    }
    togglePersonalization(drawer, miyStep);
    $dom.personalizeArrow.slideToggle('slow');
    $dom.personalizeInput.attr('type', 'text');
    $dom.personalizeOrientationSelect.css('display', 'flex');
    $dom.personalize.addClass('personalize-is-active');

    $dom.closeDrawer.css('display', 'flex');
  };

  /**
   * closePersonalization - currently not sure if the click event this is tied to actually runs
   * @param {Element} parent
   */
  const closePersonalization = (parent) => {
    //reset the orientation and the initials input
    $dom.personalizeOrientationVertical.click();

    // Close Drawer and X, Reset the Personalized button
    $dom.personalizeTriggerWrapper.slideToggle("slow");
    $dom.personalizeDrawer.slideToggle("slow");
    $dom.personalize.removeClass('personalize-is-active');
    clearErrors();
    $dom.closeDrawer.css('display', 'none');
    parent.dataset.isPersonalizationOpen = 'false';
  };

  const changePersonalizeOrientation = (personalizeOrientationButton) => {
    const maxLen = $(personalizeOrientationButton).attr("data-val");
    const placeHolder = $(personalizeOrientationButton).attr("data-placeholder");
    const placeholderSplit = placeHolder.split('');
    const orientation = $(personalizeOrientationButton).attr('data-personalization-orientation');

    $dom.personalizeInput
      .val("")
      .attr("maxlength", maxLen)
      .attr("minlength", maxLen)
      .attr("placeholder", placeHolder)
      .attr("pattern", `[A-Za-z]{${maxLen}}`)
      .attr('title', `Please lengthen this text to ${maxLen} characters.`)

    $dom.personalizeOrientation.removeClass("drawer-orientation-active");
    $(personalizeOrientationButton).addClass("drawer-orientation-active");

    $dom.personalizeOrientationText.text('');
    $dom.personalizeOrientationText.html(`<span class="prev-horizontal">${placeHolder}</span>`);
    $dom.personalizeOrientationInput.val(orientation);

    if (placeholderSplit.length === 2) {
      $dom.personalizeOrientationText.html(`<span class="prev-vertical">${placeholderSplit[0]}</span><hr class="personalized-hr-ingot"><span>${placeholderSplit[1]}</span>`)
      $(".personalized-hr-ingot").css('backgroundColor', generalIngotTextColor);
    }

    const wrapper = personalizeOrientationButton.closest('.product-personalize-wrapper');
    if (wrapper && wrapper.dataset && wrapper.dataset.isPersonalizationOpen == 'true') {
      updateATC(true);
    }
  };

  const hasCompleteInitials = (step) => {
    const input = step.querySelector('[data-personalize-input]');
    return !input
      || step.querySelector('.drawer-ingot-active[data-ingot-type="college"]') !== null
      || new RegExp(`^(?:${input.pattern})$`).test(input.value);
  };

  const updateMIYButtons = () => {
    window.Product.disableATC();
    const step = document.querySelector('.miy-step--personalized');
    const toggle = step && step.querySelector('[data-toggle-personalization]');
    if (toggle) {
      toggle.disabled = step.dataset.personalized !== 'true' && !hasCompleteInitials(step);
    }
  };

  const updateATC = (disabled) => {
    if (isMIY()) {
      updateMIYButtons();
      return;
    }
    if (!disabled && $(".product--atc-button").hasClass(`oos`)) {
      return;
    }
    $(".product--atc-button").attr("disabled", disabled);
    $(".product--atc-button").toggleClass(`disabled`, disabled);
  };

  const clearErrors = () => {
    $dom.personalizeInput.removeClass('error')
    $dom.personalizeError.removeClass('error').empty()
    updateATC(false);
  }

  const changeInitals = (event) => {
    const $input = $(event.currentTarget);
    const prevText = $input.val().toUpperCase().replace(/[^a-z0-9]/gi, ``);
    $dom.personalizeOrientationText.text('');

    updateATC(true);
    $dom.personalizeInput.addClass('error')
    $dom.personalizeError.addClass('error').html('<p>Please fill all options before proceeding</p>')
    $dom.personalizeOrientationText.html(`<span class="prev-horizontal">${prevText}</span>`);

    if ($input.attr("maxlength") == "2" && prevText.length === 2) {
      const prevTextSplit = prevText.split('');
      $dom.personalizeOrientationText.html(`<span class="prev-vertical">${prevTextSplit[0]}</span><hr class="personalized-hr-ingot"><span>${prevTextSplit[1]}</span>`);
      $(".personalized-hr-ingot").css('backgroundColor', generalIngotTextColor);
      clearErrors()
    }

    if ($input.attr("maxlength") == "3" && prevText.length === 3) {
      clearErrors()
    }

    $input.val(prevText);
    $dom.personalizeInitalsInput.val(prevText);
  }

  const initIngotPersonalization = () => {
    // Make Personalization Requred on Ingot
    if (window.location.pathname.includes('/products/personalized-ingot')) {
      $dom.personalizeTrigger.click()
      $dom.personalizeArrow.addClass('hide');
      $dom.closeDrawer.addClass('hide');
    }
  }

  const activateOrientation = ($orientation) => {
    $orientation.show();
    $orientation.addClass(`is-active`);
  };

  const deactivateOrientation = ($orientation) => {
    $orientation.hide();
    $orientation.removeClass(`is-active`);
  };

  const selectIngotDrawer = (ingotDrawer) => {
    $dom.ingotDrawer.removeClass("drawer-ingot-active");
    $dom.personalizeCollegeInput.val('');
    $dom.personalizeOrientationInput.val('');
    $dom.personalizeInitalsInput.val('');

    $(ingotDrawer).addClass("drawer-ingot-active");
    const $orientationText = $(`.orientation-text`);
    const $orientationCollege = $(`.orientation-college`);

    let collegePersonalizationInput = $orientationCollege.find(".orientation-select option:first").attr('value');
    let collegePersonalizationVariant = $orientationCollege.find(".orientation-select option:first").attr('data-variant-id');

    if ($(ingotDrawer).hasClass('ingot-text')) {
      deactivateOrientation($orientationCollege);
      activateOrientation($orientationText);
      $(".drawer-orientation-preview-text").show();
      $(".drawer-orientation-preview-college").hide();
      $(".orientation-select").css('display', 'none');
      $(".personalize-input").attr('type', 'text');
      $(".drawer-orientation-header h6").text("Orientation");
      $('[data-personalization-orientation-input]').val('Vertical');
      let ingotId = $('[data-personalization-color-variant-input]').attr('data-variant-id');
      $('[data-personalization-color-variant-input]').val(ingotId);

      $dom.personalizeCollegeInput.val('');
      $("[data-personalization-college-variant-input]").val('');
    } else if ($('.ingot-text').hasClass('drawer-ingot-active')) {
      let orientationPersonalizationInput = $orientationText.find(".js-personalization-orientation-input").val('');
      let orientationColorPersonalizationInput = $orientationText.find(".js-personalization-orientation-color-input").val('');
      $('[data-personalization-orientation-input]').val(orientationPersonalizationInput);
      let ingotId = $('[data-personalization-color-variant-input]').attr('data-variant-id');
      $('[data-personalization-color-variant-input]').val(ingotId);
    } else {
      deactivateOrientation($orientationText);
      activateOrientation($orientationCollege);
      $(".drawer-orientation-preview-text").hide();
      $(".drawer-orientation-preview-college").show();
      $(".personalize-input").attr('type', 'hidden');
      $(".orientation-select").css('display', 'flex');
      $(".drawer-orientation-header h6").text("University Name");
      $('[data-personalization-orientation-input]').val('');
      $('[data-personalization-initials-input]').val('');
      $("[data-personalization-color-variant-input]").val('');
      $dom.personalizeCollegeInput.val(collegePersonalizationInput);
      $('[data-personalization-college-variant-input]').val(collegePersonalizationVariant);
      if ($(ingotDrawer).hasClass('ingot-text')) {
        $('[data-personalization-orientation-input]').val('Vertical');
      }
    }

    if (isMIY()) {
      updateMIYButtons();
    }
  }

  const initDrawer = () => {
    $dom.ingotDrawer.click(function (event) {
      selectIngotDrawer(event.currentTarget);
    });
  }

  const initPersonalize = () => {
    changePersonalizeOrientation($dom.personalizeOrientationVertical);
    selectIngotDrawer($dom.ingotText);
    const placeHolder = ($dom.personalizeOrientationVertical.attr("data-placeholder") === undefined) ? 'AB' : $dom.personalizeOrientationVertical.attr("data-placeholder")
    const placeholderSplit = placeHolder.split('');
    $dom.personalizeOrientationText.html(`<span class="prev-vertical">${placeholderSplit[0]}</span><hr class="personalized-hr-ingot"><span>${placeholderSplit[1]}</span>`);
  };

  const runProductPersonalize = () => {
    const $displayValues = $(".product-template #AddToCartForm .js-product-variant-display-value");
    let $activeItem = $displayValues.filter('.is-active');
    let assetUrl = $(".personalize-cta").attr("data-asset");

    if ($activeItem.length === 0) {
      $activeItem = $displayValues.first();
      getLookupTableData(window.bvaccel.product.variants[0].sku, assetUrl);
    } else {
      $activeItem.each((index, item) => {
        const ingotSku = $(item).attr("data-variant-sku");
        if (!ingotSku) {
          return;
        }
        getLookupTableData(ingotSku, assetUrl);
      });
    }

    $(".product-template #AddToCartForm .js-product-variant-display-value").click(function () {
      const hasPersonalization = isMIY() ? $(this).closest(`.miy-step`).find(`.product-personalize`).length > 0 : $(this).closest(`form`).find(`.product-personalize`).length > 0;
      if (!hasPersonalization) return;
      const ingotSku = $(this).attr("data-variant-sku");
      const productHandle = $(this).attr("data-product-handle");
      getLookupTableData(ingotSku, assetUrl, productHandle);
    });

    $(".orientation-college .orientation-select").change(function () {
      let selectImage = $(".orientation-college .orientation-select option:selected").attr("data-img");
      let selectId = $(".orientation-college .orientation-select option:selected").attr("data-variant-id");

      $(".ingot-college img").attr('src', selectImage);
      $(".drawer-orientation-preview-college").css('background-image', 'url(' + selectImage + ')');

      let collegeSelect = $(".orientation-college .orientation-select option:selected").val();

      $dom.personalizeCollegeInput.val(collegeSelect);
      $('[data-personalization-college-variant-input]').val(selectId);
    });
  };

  const getValidIngotColorStrings = (ingotColorStringsArray) => {
    return ingotColorStringsArray
      .filter((ingotColorString) => {
        const ingotColorArray = ingotColorString.split(`,`);
        return ingotColorArray.length === 2;
      })
      .map((ingotColorString) => {
        const ingotColorArray = ingotColorString.split(`,`);
        return {
          label: ingotColorArray[0],
          value: ingotColorArray[1]
        };
      });
  };

  const updatePersonalizeTextColorList = (ingotColorsArray) => {
    $dom.personalizeTextColorSelect.empty();
    $dom.personalizeTextColorList.empty();
    ingotColorsArray.forEach((ingotColorObject, index) => {
      $dom.personalizeTextColorList.append(`<li class="personalize-color-value ${index === 0 && `is-active`}" data-personalize-text-color-swatch style="background-color: ${ingotColorObject.value}" data-value="${ingotColorObject.value}">${ingotColorObject.label}</li>`);
      $dom.personalizeTextColorSelect.append(`<option value="${ingotColorObject.value}">${ingotColorObject.label}</option>`);
    });
    if (ingotColorsArray.length > 1) {
      $dom.personalizeTextColorSection.show();
    } else {
      $dom.personalizeTextColorSection.hide();
    }
  };

  const setActiveTextColorSwatch = (swatch) => {
    const $swatch = $(swatch);
    $(`[data-personalize-text-color-swatch]`).removeClass(`is-active`);
    $swatch.addClass(`is-active`);
    $dom.personalizeTextColorSelect.val($swatch.data(`value`)).change();
  };

  const updateIngotTextColor = (hexColor, hexColorReadable) => {
    generalIngotTextColor = hexColor;
    // Updating the color of the text on ingot
    $(".drawer-orientation-preview-text").css('color', generalIngotTextColor);
    $dom.personalizeTextColorInput.val(generalIngotTextColor);
    $dom.personalizeTextColorReadableInput.val(hexColorReadable);
    // Updating the color of the hr on ingot separating both letter when vertical
    $(".personalized-hr-ingot").css('backgroundColor', generalIngotTextColor);
  };

  const updateIngot = (textColor, textColorsList, ingotId, ingotImage) => {
    let hexColor = null;
    let hexColorReadable = null;
    if (textColorsList && textColorsList.length > 0) {
      const validIngotColorsList = getValidIngotColorStrings(textColorsList);
      hexColor = validIngotColorsList[0].value;
      hexColorReadable = validIngotColorsList[0].label;
      updatePersonalizeTextColorList(validIngotColorsList);
    } else if (textColor) {
      hexColor = textColor;
      $dom.personalizeTextColorSection.hide();
      hexColorReadable = `Default`;
    }
    updateIngotTextColor(hexColor, hexColorReadable);
    // Updating the ingotId
    $("[data-personalization-color-variant-input]").val(ingotId);
    $("[data-personalization-color-variant-input]").attr('data-variant-id', ingotId);
    // Updating the image of the ingot
    $(".ingot-text img").attr('src', ingotImage);
    $(".drawer-orientation-preview-text").css('background-image', 'url(' + ingotImage + ')');
  };

  const personalizeProduct = (currentIngotSku, productHandle) => {
    if (!window.bvaccel.product_personalize || currentIngotLookupSKU !== currentIngotSku) {
      return;
    }
    let matchSku = window.bvaccel.product_personalize.find(function (sku) {
      let match = sku.split(",");
      let matchy = match[0] + match[1];

      if (currentIngotSku.includes(matchy)) {
        return sku;
      }
    });

    if (matchSku !== undefined) {

      let matchArr = matchSku.split(",");

      let matchIngot = matchArr[2];
      let matchColleges = matchArr[3].split(" ; ");

      let lookupIngot = window.bvaccel.customization.ingot;
      let lookupColleges = window.bvaccel.customization.college;

      let variantIngot = lookupIngot ? 
        lookupIngot.variants.find(function (variant) {
          let match = variant.option1
          if (match == matchIngot) {
            return variant;
          }
        }) : 
        null;

      if (variantIngot == undefined || variantIngot === null) {
        $dom.ingotText.hide();
        const $orientationText = $(`.orientation-text`);
        const $orientationCollege = $(`.orientation-college`);
        deactivateOrientation($orientationText);
        $(".drawer-orientation-preview-text").hide();
        $(".ingot-college").show();
        activateOrientation($orientationCollege);
        $(".drawer-orientation-preview-college").show();
        $(".ingot-college").click();
      } else {
        const ingotImage = variantIngot.featured_image.src;
        const ingotId = variantIngot.id;
        const pathArray = window.location.pathname.split(`/products/`);
        let originalProductHandle = productHandle;
        if (!productHandle) {
          originalProductHandle = window.location.pathname.includes(`/products/`) && pathArray.length > 0 ? pathArray[pathArray.length - 1] : window.bvaccel.product.handle;
        }
        // Set up text color on ingot ( and background ) by setting up which sku to find. requesting product Shopify Ajax API / looping though the ingot variants and getting the metafield color.
        // if on https://stitchgolf.com/products/personalized-ingot, the sku is:
        let ingotSkuToFind = currentIngotSku;
        // if on SL2 bag page or any other product where the customization happen after clicking on the PERSONALISATION button, the sku is:
        if (window.bvaccel.isPersonalizedIngot === false) {
          ingotSkuToFind = variantIngot.sku
        }
        
        const $personalizationWrapper = $(`.product-personalize-wrapper`);
        const $currentVariantSwatch = $personalizationWrapper.length > 0 && $personalizationWrapper.closest(`form`).find(`[data-variant-sku="${ currentIngotSku }"]`);
        if ($currentVariantSwatch.length > 0) {
          updateIngot($currentVariantSwatch.data(`text-color`), $currentVariantSwatch.data(`text-color-list`) && $currentVariantSwatch.data(`text-color-list`).split(`|`), ingotId, ingotImage);
        } else {
          // Using Shopify Ajax API to call the products in order to get the color of the ingot text setup in the metafield
          $.ajax({
            url: `/products/${originalProductHandle}?view=json`,
            type: `GET`
          })
            .done(function (data) {
              const parsedIngotProduct = $.parseJSON(data);
              const currentIngotVariant = parsedIngotProduct.variants.find((parsedIngotVariant) => {
                //Finding variant with sku ( some sku have longer strings )
                return parsedIngotVariant.sku === currentIngotSku;
              })
              updateIngot(currentIngotVariant && currentIngotVariant.textColorFromMetafield, currentIngotVariant && currentIngotVariant.textColorsListFromMetafield, ingotId, ingotImage);
            })
            .fail(function (data) {
              console.error('getAndSetIngotTextColor Failed ' + data);
            });
        }
      }
      let collegeArr = [];

      if (lookupColleges) {
        matchColleges.forEach(function (matchCollege) {
          lookupColleges.variants.find(function (variant) {
            let match = variant.option1;
            if (match == matchCollege) {
              collegeArr.push(variant);
              return variant;
            }
          });
        });
      }

      if (collegeArr == [] || collegeArr == '') {
        $(".ingot-college").hide();
        const $orientationCollege = $(`.orientation-college`);
        const $orientationText = $(`.orientation-text`);
        deactivateOrientation($orientationCollege);
        $(".drawer-orientation-preview-college").hide();
        $dom.ingotText.show();
        activateOrientation($orientationText);
        $(".drawer-orientation-preview-text").show();
        $dom.ingotText.click();
      } else {
        $(".orientation-college .orientation-select").html('');

        collegeArr.forEach(function (college) {
          $(".orientation-college .orientation-select").append(`<option data-img=${college.featured_image.src} value="${college.option1}" data-variant-id="${college.id}">${college.option1}</option>`);
        });

        let collegeImage = collegeArr[0].featured_image.src;
        $(".ingot-college img").attr('src', collegeImage);
        $(".drawer-orientation-preview-college").css('background-image', 'url(' + collegeImage + ')');
      }

      let ingotPrice = lookupIngot ? (lookupIngot.price / 100).toFixed(2) : 0;
      let collegePrice = lookupColleges ? (lookupColleges.price / 100).toFixed(2) : 0;

      if (ingotPrice) {
        $(".ingot-text .ingot-price p").text(`$${ingotPrice}`);
        $(".ingot-text").attr('data-price', ingotPrice);
      }
      if (collegePrice) {
        $(".ingot-college .ingot-price p").text(`$${collegePrice}`);
        $(".ingot-college").attr('data-price', collegePrice);
      }
    }
  };

  const getLookupTableData = (currentIngotSku, assetUrl, productHandle) => {
    currentIngotLookupSKU = currentIngotSku;
    if (window.bvaccel.product_personalize) {
      personalizeProduct(currentIngotSku, productHandle);
    } else {
      $.get(assetUrl, function (data) {
        window.bvaccel.product_personalize = data.split(/\r\n|\n/);
        personalizeProduct(currentIngotSku, productHandle);
      });
    }
  };

  const togglePersonalization = (drawer) => {
    const wrapper = drawer.closest('.product-personalize-wrapper')
    const isOpened = wrapper.dataset.isPersonalizationOpen;
    if(isOpened === 'true') {
      wrapper.dataset.isPersonalizationOpen = 'false';
      clearErrors();
    }
    else {
      wrapper.dataset.isPersonalizationOpen = 'true';
    }
  };

  const addToCart = () => {
    const button = document.querySelector('.product-miy-template [data-atc-button]');
    if (!button) {
      return;
    }
    button.addEventListener('click', async () => {
      const selectedProducts = [...document.querySelectorAll('.miy-step .is-active[data-swatch-color]')];
      const personalizationStep = document.querySelector('.product-template .miy-step--personalized[data-personalized="true"]');
      const bundleId = Math.floor(Math.random() * 90000) + 10000;
      // const personalizedItem = InlineCart.addPersonalization(document.querySelector('.product-template #AddToCartForm'));
      // const ingotVariant = window.bvaccel.customization.ingot.variants.find(function (entry) { return entry.id === Number(personalizedItem.id); }) || null;

      const productIds = selectedProducts.map((product, index) => ({
        quantity: 1,
        id: product.dataset.swatchId,
        properties: {
          _Bundle_Type: 'MIY',
          _Bundle_Id: bundleId,
          _Bundle_Size: personalizationStep ? selectedProducts.length + 1 : selectedProducts.length,
          // Initials_Orientation: personalizedItem.properties.Ingot_Initials,
          // Ingot_Initials: personalizedItem.properties.Ingot_Initials,
          // Ingot_Type: personalizedItem.properties.Ingot_Type,
          // _Customizations_Pack_Id: personalizedItem.properties._Customizations_Pack_Id,
          // Customizations_For: ingotVariant ? ingotVariant.name : null,
          // Customization: ingotVariant ? ingotVariant.name : null
        },
      })).filter(item => item.id);

      productIds[0].properties._Bundle_Main_Item = true;

      if (personalizationStep) {
        const personalizedItem = InlineCart.addPersonalization(document.querySelector('.product-template #AddToCartForm'));
        const personalizationIndex = personalizationStep.dataset.personalizationIndex;
        if (personalizedItem && personalizedItem.id) {
          const ingotVariant = window.bvaccel.customization.ingot.variants.find(function (entry) { return entry.id === Number(personalizedItem.id); });
          personalizedItem.properties._Bundle_Type = 'MIY';
          personalizedItem.properties._Bundle_Id = bundleId;
          personalizedItem.properties._Bundle_Size = selectedProducts.length + 1;
          productIds[personalizationIndex].properties.Initials_Orientation = personalizedItem.properties.Initials_Orientation;
          productIds[personalizationIndex].properties.Ingot_Initials = personalizedItem.properties.Ingot_Initials;
          productIds[personalizationIndex].properties.Ingot_Type = personalizedItem.properties.Ingot_Type;
          productIds[personalizationIndex].properties._Customizations_Pack_Id = personalizedItem.properties._Customizations_Pack_Id;
          productIds[personalizationIndex].properties.Customizations_For = ingotVariant.name;
          productIds[personalizationIndex].properties.Customization = ingotVariant.name;
          productIds[personalizationIndex].properties._Ingot_Text_Color = personalizedItem.properties._Ingot_Text_Color;
          productIds[personalizationIndex].properties._Ingot_Text_Color_Readable = personalizedItem.properties._Ingot_Text_Color_Readable;
          InlineCart.addApparelMagicEmblem(productIds[personalizationIndex].properties, personalizedItem.properties.Ingot_Initials);

          productIds.splice(personalizationIndex, 0, personalizedItem);
        }
      }



      $.ajax({
        type: 'POST',
        url: '/cart/add.js',
        data: {
          items: productIds.reverse()
        },
        complete: () => {
          InlineCart.miniCartLoad(true, true);
        }
      });
    });
  };

  const addPersonalization = () => {
    const buttons = Array.from(document.querySelectorAll('[data-toggle-personalization]'));
    buttons.map(button => {
      button.addEventListener('click', (event) => {
        const isAdded = button.dataset.togglePersonalization;
        button.dataset.togglePersonalization = isAdded === 'true' ? 'false' : 'true';
        button.textContent = isAdded === 'false' ? 'Remove Personalization' : 'Add Personalization';
        const miyStep = button.closest('.miy-step--personalized');
        const productPrice = document.querySelector('.product-miy-template .product_footer .product-price');

        if (miyStep) {
          miyStep.dataset.personalized = isAdded === 'true' ? 'false' : 'true';

          window.Product.updateMIYPrice();
          updateMIYButtons();
        }
      })
    });
  };

  const isMIY = () => (
    document.querySelector('.miy-step')
  );

  const init = () => {
    if (document.querySelector('[data-personalize]')) {
      cacheDom();
      bindActions();
      if (isMIY) {
       runProductPersonalize();
      }
      addPersonalization();
      addToCart();
    }
  };

  ProductPersonalize.init = init;
  ProductPersonalize.hasCompleteInitials = hasCompleteInitials;
})(window.ProductPersonalize = window.ProductPersonalize || {}, jQuery);
